import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import {
  PatientPhysiotherapyReportDto,
  PatientSynopsisReportDto,
  PrescriptionDto,
  UnfitDto,
  UpsertPrescriptionDto,
  UpsertUnfitDto
} from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/patient-medical-reports`;

export const getPrescription = (
    id: number, source: CancelTokenSource)
    : Promise<PrescriptionDto> => {

  return axios
      .get(`${apiUri}/prescription/${id}`, {cancelToken: source.token})
      .then(response => response.data);
}

export const savePrescription = (
    prescriptionDto: Partial<UpsertPrescriptionDto>,
    source: CancelTokenSource)
    : Promise<PrescriptionDto> => {

  return axios
      .post(`${apiUri}/prescription/save-prescription`, prescriptionDto, {cancelToken: source.token})
      .then(response => response.data);
}

export const getUnfit = (
    id: number,
    source: CancelTokenSource)
    : Promise<UnfitDto> => {

  return axios
      .get(`${apiUri}/unfit/${id}`, {cancelToken: source.token})
      .then(response => response.data);
}

export const saveUnfit = (
    request: Partial<UpsertUnfitDto>,
    source: CancelTokenSource)
    : Promise<UnfitDto> => {

  return axios
      .post(`${apiUri}/unfit/save-unfit`, request, {cancelToken: source.token})
      .then(response => response.data);
}

export const migrateUnfitOrPrescriptionIntoPatientMedicalDocument = (
    source: CancelTokenSource)
    : Promise<string> => {

  return axios
      .post(`${apiUri}/migrate-unfits-and-prescriptions`, null, {cancelToken: source.token})
      .then(response => response.data);
}

export const getSynopsisReport = (
    id: number, source: CancelTokenSource): Promise<PatientSynopsisReportDto> => {

  return axios
      .get(`${apiUri}/synopsis-report/${id}`, {cancelToken: source.token})
      .then(response => response.data);
}

export const getPhysiotherapyReport = (
    id: number, source: CancelTokenSource): Promise<PatientPhysiotherapyReportDto> => {

  return axios
      .get(`${apiUri}/physiotherapy-report/${id}`, {cancelToken: source.token})
      .then(response => response.data);
}
